<ng-container>

    <!-- Banner text-->
    <div class="bg-banner-gradient-leader flex items-center px-4 md:px-4 lg:p-0 relative z-10  md:w-full my-8 rounded-[14px]  mx-auto w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%] "
        style="background: 
       url('../../assets/images/icon-banner.png'), 
       linear-gradient(90.17deg, 
           var(--v2-color-primary-800) 0.12%, 
           var(--v2-color-primary-700) 12.12%,
           var(--v2-color-primary-600) 37.84%, 
           var(--v2-color-primary-600) 62.7%, 
           var(--v2-color-primary-500) 86.77%);">

        <div
            class="px-4 py-8 rounded-[14px] w-[70%] md:w-full lg:w-full h-auto md:h-[200px] flex  gap-6 sm:gap-4 justify-center ">

            <!-- Title and Description -->
            <div class=" w-full flex flex-col justify-center gap-4 w-3/5 md:w-[80%] ">
                <h1 class="text-2xl font-bold text-white">{{'words.table-leaders' | translate }}</h1>
                <p class="text-white text-md leading-snug mb-2 w-full description-2 md:w-3/5 ">
                    {{'words.leaders-message' | translate }}
                </p>
            </div>
        </div>
    </div>


    <section class="grid-table bg-gray-50 py-8  px-6 lg:px-0 md:px-0">
        <!-- Primera Grid 10 top  -->
        <div
            class="bg-white rounded-[14px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-4 mx-auto w-full max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]">

            <!-- plantilla skeleton leaders table lg-->

            <div *ngIf="isSkeletonLeaders; else tableLg" class="col-span-2">
                <div class="col-span-2 animate-pulse">
                    <div class="bg-white h-full p-6 w-full">
                        <!-- Header con Título y Buscador -->
                        <div class="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                            <div class="h-6 bg-gray-200 rounded w-40"></div>
                            <div
                                class="bg-gray-100 rounded-[10px] px-2 flex items-center w-full md:w-1/2 border border-gray-200">
                                <div class="w-full p-2">
                                    <div class="h-4 bg-gray-200 rounded w-full"></div>
                                </div>
                            </div>
                        </div>

                        <!-- Tabla Skeleton -->
                        <div class="p-6 rounded-[14px] border border-gray-100">
                            <div class="h-19 rounded-[14px] overflow-y-auto scrollbar-hidden">
                                <table class="w-full">
                                    <thead>
                                        <tr class="bg-gray-50">
                                            <th class="px-4 py-2 text-left w-[100%]">
                                                <div class="h-4 bg-gray-200 rounded w-20"></div>
                                            </th>
                                            <th class="px-4 py-2  w-[20%]">
                                                <div class="h-4 bg-gray-200 rounded w-10 mx-auto"></div>
                                            </th>
                                            <th class="px-4 py-2  w-[20%]">
                                                <div class="h-4 bg-gray-200 rounded w-10 mx-auto"></div>
                                            </th>
                                            <th class="px-4 py-2 w-[20%]">
                                                <div class="h-4 bg-gray-200 rounded w-10 mx-auto"></div>
                                            </th>
                                            <th class="px-4 py-2 w-[20%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Repite esta fila 5 veces si deseas -->
                                        <tr class="border-b">
                                            <td class="p-2 flex items-center gap-3">
                                                <div class="w-12 h-12 bg-gray-200 rounded-full"></div>
                                                <div class="space-y-1">
                                                    <div class="h-4 bg-gray-200 rounded w-24"></div>
                                                    <div class="h-3 bg-gray-100 rounded w-16"></div>
                                                </div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                        </tr>
                                        <!-- Puedes clonar este <tr> varias veces si necesitas más skeletons -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #tableLg>
                <div class="col-span-2 ">
                    <div class="bg-white h-full p-6 w-full  ">
                        <div class="h-full flex flex-col">
                            <div
                                class="header-text-table flex flex-col md:flex-row  justify-between items-center gap-4 mb-6">
                                <h3 class="text-lg font-bold text-gray-700">{{'words.top' | translate }} 10 | Plataforma
                                </h3>
                                <div
                                    class="bg-white rounded-[10px] px-2 flex items-center w-full  md:w-2/5 border-[1px] shadow-sm border-gray-200">
                                    <input type="text" placeholder="Buscar líder"
                                        class="w-full p-2 pr-8 focus:outline-none font-[400] text-sm" />
                                    <button class="bg-transparent p-2 flex-shrink-0 -ml-8">
                                        <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                                    </button>
                                </div>
                            </div>
                            <!-- Contenedor con scroll -->
                            <div class="flex-1 p-6 rounded-[14px] overflow-y-auto card-academy border border-gray-100">
                                <table class="w-full">
                                    <!-- Encabezado de la tabla -->
                                    <thead>
                                        <tr class="bg-gray-50 rounded-[14px]">
                                            <!-- Columna: Nombre (imagen y nombre) -->
                                            <th class="px-4 py-2 text-left w-[100%]">
                                                <div class="flex items-center gap-2">
                                                    <span class="font-semibold">Nombre</span>
                                                </div>
                                            </th>
                                            <!-- Columna: Posición con ícono -->
                                            <th class="p-2 text-left w-[10%]">
                                                <div class="flex items-center gap-2 justify-center">
                                                    <span class="font-semibold">Posición</span>
                                                    <i class="newicon-icon-position text-md  flex items-center justify-center text-gray-700"
                                                        syle="max-width:fit-content;"></i>
                                                </div>
                                            </th>
                                            <!-- Columna: Cursos con ícono -->
                                            <th class="p-6 py-2 text-left w-[10%]">
                                                <div class="flex items-center gap-2 justify-center">
                                                    <span class="font-semibold">Cursos</span>
                                                    <i class="newicon-icon-course text-sm  flex items-center justify-center text-gray-700"
                                                        syle="max-width:fit-content;"></i>
                                                </div>
                                            </th>
                                            <!-- Columna: Rutas con ícono -->
                                            <th class="px-6 py-2 text-left w-[20%]">
                                                <div class="flex items-center gap-2 justify-center">
                                                    <span class="font-semibold">Rutas</span>
                                                    <i class="newicon-icon-ruta text-md  flex items-center justify-center text-gray-700"
                                                        syle="max-width:fit-content;"></i>
                                                </div>
                                            </th>
                                            <!-- Columna: Tiempo (con ícono de reloj) -->
                                            <th class="px-4 py-2 text-left w-[10%]">
                                                <div class="flex items-center gap-2 justify-center">
                                                    <i class="fa-regular fa-clock text-sm "
                                                        style=" color: #787878;"></i>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <!-- Cuerpo de la tabla -->
                                    <tbody>
                                        <!-- Fila 1 -->
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <tr class="register border-b">
                                            <!-- Columna 1: Nombre (imagen y nombre) -->
                                            <!-- Columna: Foto y Nombre -->
                                            <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                <img src="https://netzunplus.s3.amazonaws.com/media/courses/photos/2021/12/01/dejgl-bafca4dc-52e0-11ec-91ea-0a58a9feac02.webp?size=512"
                                                    alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                <div class="truncate">
                                                    <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                        title="Juan Pérez">
                                                        Jesse Thomas Garcia
                                                    </div>
                                                    <div class="text-xs text-gray-500">
                                                        <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <!-- Columna 2: Posición -->
                                            <td class="p-2 w-1/5">
                                                <div class="flex items-center justify-center">
                                                    <span
                                                        class="w-10 text-sm font-semibold text-gray-500 text-center">12</span>
                                                    <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                </div>
                                            </td>
                                            <!-- Columna 3: Cursos -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span
                                                    class="w-10 text-sm font-semibold text-gray-500 text-center">15</span>
                                            </td>
                                            <!-- Columna 4: Rutas -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="text-sm text-gray-500">2</span>
                                            </td>
                                            <!-- Columna 5: Tiempo (Reloj) -->
                                            <td class="px-6 py-2 text-center justify-center">
                                                <span class="ml-1 text-sm text-gray-500">438</span>
                                            </td>
                                        </tr>
                                        <!-- Repetir filas con el mismo formato -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <!-- Segunda columna SM (dos tablas en dos filas) 5 tops -->
            <div
                class="col-span-2 md:col-span-2 lg:col-span-1 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 2xl:grid-cols-1 lg:grid-cols-1">
                <div *ngIf="isSkeletonLeadersSm; else tableSm" class="SkeletonCardSm">
                    <div class="col-span-1 animate-pulse">
                        <div class="bg-white p-6 w-full">
                            <!-- Header con Título y Buscador -->
                            <div class="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                                <div class="h-6 bg-gray-200 rounded w-40"></div>
                                <div
                                    class="bg-gray-100 rounded-[10px] px-2 flex items-center w-full md:w-1/2 border border-gray-200">
                                    <div class="w-full p-2">
                                        <div class="h-4 bg-gray-200 rounded w-full"></div>
                                    </div>

                                </div>
                            </div>

                            <!-- Tabla Skeleton -->
                            <div class="p-6 rounded-[14px] border border-gray-100">
                                <div class="h-19 rounded-[14px] overflow-y-auto scrollbar-hidden">
                                    <table class="w-full">
                                        <thead>
                                            <tr class="bg-gray-50">
                                                <th class="px-4 py-2 text-left w-[100%]">
                                                    <div class="h-4 bg-gray-200 rounded w-24"></div>
                                                </th>
                                                <th class="p-2 w-[10%]">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </th>
                                                <th class="p-2 w-[10%]">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </th>
                                                <th class="p-2 w-[10%]">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- Repite esta fila 5 veces si deseas -->
                                            <tr class="border-b">
                                                <td class="p-2 flex items-center gap-3">
                                                    <div class="w-12 h-12 bg-gray-200 rounded-full"></div>
                                                    <div class="space-y-1">
                                                        <div class="h-4 bg-gray-200 rounded w-24"></div>
                                                        <div class="h-3 bg-gray-100 rounded w-16"></div>
                                                    </div>
                                                </td>
                                                <td class="p-2">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </td>
                                                <td class="p-2">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </td>
                                                <td class="p-2">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </td>
                                            </tr>
                                            <!-- Puedes clonar este <tr> varias veces si necesitas más skeletons -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #tableSm>
                    <div class="col-span-1">
                        <div class="bg-white p-6 w-full">
                            <div
                                class="header-text-table flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                                <h3 class="text-lg font-bold text-gray-700 truncate">{{'words.top' | translate }} 5 |
                                    Nombre Catálogo</h3>
                                <div
                                    class="bg-white rounded-[10px] px-2 flex items-center w-full md:w-1/2 border-[1px] shadow-sm border-gray-200">
                                    <input type="text" placeholder="Buscar líder"
                                        class="w-full p-2 pr-8 focus:outline-none font-[400] text-sm" />
                                    <button class="bg-transparent p-2 flex-shrink-0 -ml-8">
                                        <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- Contenedor con scroll -->
                            <div class="p-6 rounded-[14px] card-academy border border-gray-100">
                                <!-- Contenedor con altura fija y scroll interno -->
                                <div class="h-19 rounded-[14px] overflow-y-auto scrollbar-hidden">
                                    <table class="w-full">
                                        <!-- Encabezado de la tabla -->
                                        <thead>
                                            <tr class="bg-gray-50 rounded-[14px]">
                                                <!-- Columna: Nombre (imagen y nombre) -->
                                                <th class="px-4 py-2 text-left w-[100%]">
                                                    <div class="flex items-center gap-2">
                                                        <span class="font-semibold">Nombre</span>
                                                    </div>
                                                </th>
                                                <!-- Columna: Posición con ícono -->
                                                <th class="p-2 text-left w-[10%]">
                                                    <div class="flex items-center gap-2 justify-center">
                                                        <i class="newicon-icon-position text-md  flex items-center justify-center text-gray-700"
                                                            syle="max-width:fit-content;"></i>
                                                    </div>
                                                </th>
                                                <!-- Columna: Cursos con ícono -->
                                                <th class="p-2 text-left w-[10%]">
                                                    <div class="flex items-center gap-2 justify-center">
                                                        <i class="newicon-icon-course text-sm  flex items-center justify-center text-gray-700"
                                                            syle="max-width:fit-content;"></i>
                                                    </div>
                                                </th>
                                                <!-- Columna: Tiempo (con ícono de reloj) -->
                                                <th class="px-4 py-2 text-left w-[10%]">
                                                    <div class="flex items-center gap-2 justify-center">
                                                        <i class="fa-regular fa-clock text-sm "
                                                            style=" color: #787878;"></i>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- Filas de la tabla (repetidas 5 veces) -->
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <div *ngIf="isSkeletonLeadersSm; else tableSm" class="SkeletonCardSm">
                    <div class="col-span-1 animate-pulse">
                        <div class="bg-white p-6 w-full">
                            <!-- Header con Título y Buscador -->
                            <div class="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                                <div class="h-6 bg-gray-200 rounded w-40"></div>
                                <div
                                    class="bg-gray-100 rounded-[10px] px-2 flex items-center w-full md:w-1/2 border border-gray-200">
                                    <div class="w-full p-2">
                                        <div class="h-4 bg-gray-200 rounded w-full"></div>
                                    </div>

                                </div>
                            </div>

                            <!-- Tabla Skeleton -->
                            <div class="p-6 rounded-[14px] border border-gray-100">
                                <div class="h-19 rounded-[14px] overflow-y-auto scrollbar-hidden">
                                    <table class="w-full">
                                        <thead>
                                            <tr class="bg-gray-50">
                                                <th class="px-4 py-2 text-left w-[100%]">
                                                    <div class="h-4 bg-gray-200 rounded w-24"></div>
                                                </th>
                                                <th class="p-2 w-[10%]">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </th>
                                                <th class="p-2 w-[10%]">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </th>
                                                <th class="p-2 w-[10%]">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- Repite esta fila 5 veces si deseas -->
                                            <tr class="border-b">
                                                <td class="p-2 flex items-center gap-3">
                                                    <div class="w-12 h-12 bg-gray-200 rounded-full"></div>
                                                    <div class="space-y-1">
                                                        <div class="h-4 bg-gray-200 rounded w-24"></div>
                                                        <div class="h-3 bg-gray-100 rounded w-16"></div>
                                                    </div>
                                                </td>
                                                <td class="p-2">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </td>
                                                <td class="p-2">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </td>
                                                <td class="p-2">
                                                    <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                                </td>
                                            </tr>
                                            <!-- Puedes clonar este <tr> varias veces si necesitas más skeletons -->
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #tableSm>
                    <div class="col-span-1">
                        <div class="bg-white p-6 w-full">
                            <div
                                class="header-text-table flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                                <h3 class="text-lg font-bold text-gray-700 truncate">{{'words.top' | translate }} 5 |
                                    Nombre Catálogo</h3>
                                <div
                                    class="bg-white rounded-[10px] px-2 flex items-center w-full md:w-1/2 border-[1px] shadow-sm border-gray-200">
                                    <input type="text" placeholder="Buscar líder"
                                        class="w-full p-2 pr-8 focus:outline-none font-[400] text-sm" />
                                    <button class="bg-transparent p-2 flex-shrink-0 -ml-8">
                                        <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- Contenedor con scroll -->
                            <div class="p-6 rounded-[14px] card-academy border border-gray-100">
                                <!-- Contenedor con altura fija y scroll interno -->
                                <div class="h-19 rounded-[14px] overflow-y-auto scrollbar-hidden">
                                    <table class="w-full">
                                        <!-- Encabezado de la tabla -->
                                        <thead>
                                            <tr class="bg-gray-50 rounded-[14px]">
                                                <!-- Columna: Nombre (imagen y nombre) -->
                                                <th class="px-4 py-2 text-left w-[100%]">
                                                    <div class="flex items-center gap-2">
                                                        <span class="font-semibold">Nombre</span>
                                                    </div>
                                                </th>
                                                <!-- Columna: Posición con ícono -->
                                                <th class="p-2 text-left w-[10%]">
                                                    <div class="flex items-center gap-2 justify-center">
                                                        <i class="newicon-icon-position text-md  flex items-center justify-center text-gray-700"
                                                            syle="max-width:fit-content;"></i>
                                                    </div>
                                                </th>
                                                <!-- Columna: Cursos con ícono -->
                                                <th class="p-2 text-left w-[10%]">
                                                    <div class="flex items-center gap-2 justify-center">
                                                        <i class="newicon-icon-course text-sm flex items-center justify-center text-gray-700"
                                                            syle="max-width:fit-content;"></i>
                                                    </div>
                                                </th>
                                                <!-- Columna: Tiempo (con ícono de reloj) -->
                                                <th class="px-4 py-2 text-left w-[10%]">
                                                    <div class="flex items-center gap-2 justify-center">
                                                        <i class="fa-regular fa-clock text-sm"
                                                            style="color: #787878;"></i>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- Filas de la tabla (repetidas 5 veces) -->
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="register  border-b">
                                                <!-- Columna: Foto y Nombre -->
                                                <td class="p-2 min-w-[100px] flex items-center gap-3">
                                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                        alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                                    <div class="truncate">
                                                        <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                            title="Juan Pérez">
                                                            Juan Pérez
                                                        </div>
                                                        <div class="text-xs text-gray-500">
                                                            <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <!-- Columna 3: Número e icono de subida -->
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center gap-2">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                        <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                                <td class="p-2 w-1/5">
                                                    <div class="flex items-center">
                                                        <span
                                                            class="w-full text-sm font-semibold text-gray-500 text-center">1</span>
                                                    </div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>

        <!-- Segunda Grid 3 col 5 tops-->
        <div
            class="bg-white rounded-[14px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-4 pb-4 w-full mx-auto max-w-[90%] lg:max-w-[90%] xl:max-w-[90%] 2xl:max-w-[90%]">
            <!-- Col 1 -->

            <div *ngIf="isSkeletonLeadersSm; else tableSm" class="SkeletonCardSm">
                <div class="col-span-1 animate-pulse">
                    <div class="bg-white p-6 w-full">
                        <!-- Header con Título y Buscador -->
                        <div class="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                            <div class="h-6 bg-gray-200 rounded w-40"></div>
                            <div
                                class="bg-gray-100 rounded-[10px] px-2 flex items-center w-full md:w-1/2 border border-gray-200">
                                <div class="w-full p-2">
                                    <div class="h-4 bg-gray-200 rounded w-full"></div>
                                </div>

                            </div>
                        </div>

                        <!-- Tabla Skeleton -->
                        <div class="p-6 rounded-[14px] border border-gray-100">
                            <div class="h-19 rounded-[14px] overflow-y-auto scrollbar-hidden">
                                <table class="w-full">
                                    <thead>
                                        <tr class="bg-gray-50">
                                            <th class="px-4 py-2 text-left w-[100%]">
                                                <div class="h-4 bg-gray-200 rounded w-24"></div>
                                            </th>
                                            <th class="p-2 w-[10%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                            <th class="p-2 w-[10%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                            <th class="p-2 w-[10%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Repite esta fila 5 veces si deseas -->
                                        <tr class="border-b">
                                            <td class="p-2 flex items-center gap-3">
                                                <div class="w-12 h-12 bg-gray-200 rounded-full"></div>
                                                <div class="space-y-1">
                                                    <div class="h-4 bg-gray-200 rounded w-24"></div>
                                                    <div class="h-3 bg-gray-100 rounded w-16"></div>
                                                </div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                        </tr>
                                        <!-- Puedes clonar este <tr> varias veces si necesitas más skeletons -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #tableSm>
                <div class="col-span-1 ">
                    <div class="bg-white   p-6 w-full ">
                        <div
                            class="header-text-table flex flex-col md:flex-row  justify-between items-center gap-4 mb-6">
                            <h3 class="text-lg font-bold text-gray-700 truncate">{{'words.top' | translate }} 5 | Nombre
                                Catálogo</h3>
                            <div
                                class="bg-white rounded-[10px] px-2 flex items-center w-full  md:w-1/2 border-[1px] shadow-sm border-gray-200">
                                <input type="text" placeholder="Buscar líder"
                                    class="w-full p-2 pr-8 focus:outline-none font-[400] text-sm" />
                                <button class="bg-transparent p-2 flex-shrink-0 -ml-8">
                                    <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                                </button>
                            </div>
                        </div>


                        <!-- Contenedor con scroll -->
                        <div class="h-full p-6 rounded-[14px] card-academy border border-gray-100">
                            <table class="w-full">
                                <!-- Encabezado de la tabla -->
                                <thead>
                                    <tr class="bg-gray-50 rounded-[14px]">
                                        <!-- Columna: Nombre (imagen y nombre) -->
                                        <th class="px-4 py-2 text-left w-[100%]">
                                            <div class="flex items-center gap-2">
                                                <span class="font-semibold">Nombre</span>
                                            </div>
                                        </th>
                                        <!-- Columna: Posición con ícono -->
                                        <th class="p-2 text-left w-[10%]">
                                            <div class="flex items-center gap-2 justify-center">
                                                <i class="newicon-icon-position text-md  flex items-center justify-center text-gray-700"
                                                    syle="max-width:fit-content;"></i>
                                            </div>
                                        </th>
                                        <!-- Columna: Cursos con ícono -->
                                        <th class="p-2 text-left w-[10%]">
                                            <div class="flex items-center gap-2 justify-center">
                                                <i class="newicon-icon-course text-sm  flex items-center justify-center text-gray-700"
                                                    syle="max-width:fit-content;"></i>
                                            </div>
                                        </th>

                                        <!-- Columna: Tiempo (con ícono de reloj) -->
                                        <th class="px-4 py-2 text-left w-[10%]">
                                            <div class="flex items-center gap-2 justify-center">
                                                <i class="fa-regular fa-clock text-sm " style=" color: #787878;"></i>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-template>
            <!-- Col 2 -->


            <div *ngIf="isSkeletonLeadersSm; else tableSm" class="SkeletonCardSm">
                <div class="col-span-1 animate-pulse">
                    <div class="bg-white p-6 w-full">
                        <!-- Header con Título y Buscador -->
                        <div class="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                            <div class="h-6 bg-gray-200 rounded w-40"></div>
                            <div
                                class="bg-gray-100 rounded-[10px] px-2 flex items-center w-full md:w-1/2 border border-gray-200">
                                <div class="w-full p-2">
                                    <div class="h-4 bg-gray-200 rounded w-full"></div>
                                </div>

                            </div>
                        </div>

                        <!-- Tabla Skeleton -->
                        <div class="p-6 rounded-[14px] border border-gray-100">
                            <div class="h-19 rounded-[14px] overflow-y-auto scrollbar-hidden">
                                <table class="w-full">
                                    <thead>
                                        <tr class="bg-gray-50">
                                            <th class="px-4 py-2 text-left w-[100%]">
                                                <div class="h-4 bg-gray-200 rounded w-24"></div>
                                            </th>
                                            <th class="p-2 w-[10%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                            <th class="p-2 w-[10%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                            <th class="p-2 w-[10%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Repite esta fila 5 veces si deseas -->
                                        <tr class="border-b">
                                            <td class="p-2 flex items-center gap-3">
                                                <div class="w-12 h-12 bg-gray-200 rounded-full"></div>
                                                <div class="space-y-1">
                                                    <div class="h-4 bg-gray-200 rounded w-24"></div>
                                                    <div class="h-3 bg-gray-100 rounded w-16"></div>
                                                </div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                        </tr>
                                        <!-- Puedes clonar este <tr> varias veces si necesitas más skeletons -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #tableSm>
                <div class="col-span-1 ">
                    <div class="bg-white   p-6 w-full ">
                        <div
                            class="header-text-table flex flex-col md:flex-row  justify-between items-center gap-4 mb-6">
                            <h3 class="text-lg font-bold text-gray-700 truncate">{{'words.top' | translate }} 5 | Nombre
                                Catálogo</h3>
                            <div
                                class="bg-white rounded-[10px] px-2 flex items-center w-full  md:w-1/2 border-[1px] shadow-sm border-gray-200">
                                <input type="text" placeholder="Buscar líder"
                                    class="w-full p-2 pr-8 focus:outline-none font-[400] text-sm" />
                                <button class="bg-transparent p-2 flex-shrink-0 -ml-8">
                                    <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                                </button>
                            </div>
                        </div>


                        <!-- Contenedor con scroll -->
                        <div class="h-full p-6 rounded-[14px] card-academy border border-gray-100">
                            <table class="w-full">
                                <!-- Encabezado de la tabla -->
                                <thead>
                                    <tr class="bg-gray-50 rounded-[14px]">
                                        <!-- Columna: Nombre (imagen y nombre) -->
                                        <th class="px-4 py-2 text-left w-[100%]">
                                            <div class="flex items-center gap-2">
                                                <span class="font-semibold">Nombre</span>
                                            </div>
                                        </th>
                                        <!-- Columna: Posición con ícono -->
                                        <th class="p-2 text-left w-[10%]">
                                            <div class="flex items-center gap-2 justify-center">
                                                <i class="newicon-icon-position text-md  flex items-center justify-center text-gray-700"
                                                    syle="max-width:fit-content;"></i>
                                            </div>
                                        </th>
                                        <!-- Columna: Cursos con ícono -->
                                        <th class="p-2 text-left w-[10%]">
                                            <div class="flex items-center gap-2 justify-center">
                                                <i class="newicon-icon-course text-sm  flex items-center justify-center text-gray-700"
                                                    syle="max-width:fit-content;"></i>
                                            </div>
                                        </th>

                                        <!-- Columna: Tiempo (con ícono de reloj) -->
                                        <th class="px-4 py-2 text-left w-[10%]">
                                            <div class="flex items-center gap-2 justify-center">
                                                <i class="fa-regular fa-clock text-sm " style=" color: #787878;"></i>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-template>
            <!-- Col 3 -->

            <div *ngIf="isSkeletonLeadersSm; else tableSm" class="SkeletonCardSm">
                <div class="col-span-1 animate-pulse">
                    <div class="bg-white p-6 w-full">
                        <!-- Header con Título y Buscador -->
                        <div class="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
                            <div class="h-6 bg-gray-200 rounded w-40"></div>
                            <div
                                class="bg-gray-100 rounded-[10px] px-2 flex items-center w-full md:w-1/2 border border-gray-200">
                                <div class="w-full p-2">
                                    <div class="h-4 bg-gray-200 rounded w-full"></div>
                                </div>

                            </div>
                        </div>

                        <!-- Tabla Skeleton -->
                        <div class="p-6 rounded-[14px] border border-gray-100">
                            <div class="h-19 rounded-[14px] overflow-y-auto scrollbar-hidden">
                                <table class="w-full">
                                    <thead>
                                        <tr class="bg-gray-50">
                                            <th class="px-4 py-2 text-left w-[100%]">
                                                <div class="h-4 bg-gray-200 rounded w-24"></div>
                                            </th>
                                            <th class="p-2 w-[10%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                            <th class="p-2 w-[10%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                            <th class="p-2 w-[10%]">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Repite esta fila 5 veces si deseas -->
                                        <tr class="border-b">
                                            <td class="p-2 flex items-center gap-3">
                                                <div class="w-12 h-12 bg-gray-200 rounded-full"></div>
                                                <div class="space-y-1">
                                                    <div class="h-4 bg-gray-200 rounded w-24"></div>
                                                    <div class="h-3 bg-gray-100 rounded w-16"></div>
                                                </div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                            <td class="p-2">
                                                <div class="h-4 bg-gray-200 rounded w-6 mx-auto"></div>
                                            </td>
                                        </tr>
                                        <!-- Puedes clonar este <tr> varias veces si necesitas más skeletons -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #tableSm>
                <div class="col-span-1 ">
                    <div class="bg-white   p-6 w-full ">
                        <div
                            class="header-text-table flex flex-col md:flex-row  justify-between items-center gap-4 mb-6">
                            <h3 class="text-lg font-bold text-gray-700 truncate">{{'words.top' | translate }} 5 | Nombre
                                Catálogo</h3>
                            <div
                                class="bg-white rounded-[10px] px-2 flex items-center w-full  md:w-1/2 border-[1px] shadow-sm border-gray-200">
                                <input type="text" placeholder="Buscar líder"
                                    class="w-full p-2 pr-8 focus:outline-none font-[400] text-sm" />
                                <button class="bg-transparent p-2 flex-shrink-0 -ml-8">
                                    <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                                </button>
                            </div>
                        </div>


                        <!-- Contenedor con scroll -->
                        <div class="h-full p-6 rounded-[14px] card-academy border border-gray-100">
                            <table class="w-full">
                                <!-- Encabezado de la tabla -->
                                <thead>
                                    <tr class="bg-gray-50 rounded-[14px]">
                                        <!-- Columna: Nombre (imagen y nombre) -->
                                        <th class="px-4 py-2 text-left w-[100%]">
                                            <div class="flex items-center gap-2">
                                                <span class="font-semibold">Nombre</span>
                                            </div>
                                        </th>
                                        <!-- Columna: Posición con ícono -->
                                        <th class="p-2 text-left w-[10%]">
                                            <div class="flex items-center gap-2 justify-center">
                                                <i class="newicon-icon-position text-md  flex items-center justify-center text-gray-700"
                                                    syle="max-width:fit-content;"></i>
                                            </div>
                                        </th>
                                        <!-- Columna: Cursos con ícono -->
                                        <th class="p-2 text-left w-[10%]">
                                            <div class="flex items-center gap-2 justify-center">
                                                <i class="newicon-icon-course text-sm  flex items-center justify-center text-gray-700"
                                                    syle="max-width:fit-content;"></i>
                                            </div>
                                        </th>

                                        <!-- Columna: Tiempo (con ícono de reloj) -->
                                        <th class="px-4 py-2 text-left w-[10%]">
                                            <div class="flex items-center gap-2 justify-center">
                                                <i class="fa-regular fa-clock text-sm " style=" color: #787878;"></i>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                    <tr class="register">
                                        <!-- Columna: Foto y Nombre -->
                                        <td class="p-2 min-w-[100px] flex items-center gap-3">
                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0cCvT8UQ-sHZibxPjO3wkX7S-LndZVwE8qA&amp;s"
                                                alt="Perfil" class="w-12 h-12 rounded-full object-cover">
                                            <div class="truncate">
                                                <div class="text-sm font-medium text-gray-700 truncate max-w-[150px]"
                                                    title="Juan Pérez">
                                                    Juan Pérez
                                                </div>
                                                <div class="text-xs text-gray-500">
                                                    <p href="#" class="text-gray-500 text-xs">Level 1 - 98%</p>
                                                </div>
                                            </div>
                                        </td>


                                        <!-- Columna 3: Número e icono de subida -->
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center gap-2 ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">12</span>
                                                <i class="text-2xl fas fa-caret-up text-green-500"></i>
                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                        <td class="p-2 w-1/5">
                                            <div class="flex items-center ">
                                                <span
                                                    class="w-full text-sm font-semibold text-gray-500 text-center">1</span>

                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </section>

    <!-- FOOTER  -->
    <app-footer></app-footer>
</ng-container>